import React from 'react';
import moment from 'moment';
import { shortDateAtTime } from 'Consts/DateFormats';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import { useHistory } from 'react-router-dom';
import { clientPaths } from 'Consts/Strings';
import { dataAttrs } from 'Helpers/Testing';

const UpcomingMeetingButton = () => {
  const { clientDashboardResource } = useDashboardContext();
  const history = useHistory();

  return (
    <FDPrimaryActionButton
      onClick={() => history.push(clientPaths.myMeetings)}
      isFullWidth
      label={`Next Meeting: ${moment(clientDashboardResource.attr('upcomingMeetingDateTime')).format(shortDateAtTime)}`}
      {...dataAttrs('upcoming-meeting-button')}
    />
  );
};

UpcomingMeetingButton.defaultProps = {
};

UpcomingMeetingButton.propTypes = {
};

export default UpcomingMeetingButton;
